angular.module('logbook').directive('complexManager',['$http', '$timeout', '$q', 'errorHandler', function($http, $timeout, $q, errorHandler)
{
	return {
		restrict: 'E',
		template: require('./complex-manager.html'),
		scope: {
			onBind: '=',
			complexObject: '=?',
			watchComplex: '=',
			css: '=',
			
			onDelete: '=',
			onEdit: '=',
			onRevisionMadeActive: '=',
			onClose: '=',
			onCopy: '=',
			onComplexObjectChanged: '=',
			
			endPoint: '@'
		},
		
		link: {
			pre: function(scope, elem, attr)
			{
				var onRevisionMadeActiveCallbacks = [],
					onEditCallbacks = [],
					onDeleteCallbacks = [],
					onCopyCallbacks = [],
					onCloseCallbacks = [],
					onCpxObjectChangedCallbacks = [],
					publishAvailablePredicate = null,
					deleteAvailablePredicate = null,
					commentAvailablePredicate = null,
					types = {
						published: 'published',
						draft: 'draft',
						history: 'history'
					};
				
				scope.versionComment = '';
				
				scope.closeBtnEnabled = !attr.hasOwnProperty('disableClose');
				scope.autoDismissEnabled = !attr.hasOwnProperty('disableAutoDismiss');
				
				scope.tooltipText = 'This view provides access to the current draft,' +
					' current published version and all prior published versions.\n\n' +
					'Here you can publish the current draft, if one exists.\n\n' +
					'You can also restore any prior version by selecting it, editing it, and then ' +
					'publishing it again.\n\n' +
					'Only one draft revision is kept at any time, which is the content of the most recently saved revision.\n\n' +
					'Comments can be kept on prior versions and can be helpful to identify certain specific ' +
					'prior versions.';
				
				scope.paging = {
					count: 0,
					elements: 0,
					pageSize: 5
				};
				
				scope.historyObjsMap = {
					getAll: function()
					{
						var toReturn = scope.historyObjsMap.history.concat([]);
						if (scope.historyObjsMap.draft)
							toReturn.splice(0, 0, scope.historyObjsMap.draft);
						if (scope.historyObjsMap.published)
							toReturn.splice(0, 0, scope.historyObjsMap.published);
						return toReturn;
					},
					getMap: function()
					{
						return scope.historyObjsMap.getAll().reduce(function(map, current)
						{
							map[current.id] = current;
							return map;
						}, {})
					},
					current: undefined,
					published: undefined,
					draft: undefined,
					history: []
				};
				
				/**
				 * Sets object type and readable dates onto provided object
				 * @param obj
				 */
				function prepare(obj)
				{
					if (!obj)
						return obj;
					
					obj.readableDate = moment(obj.created).format('M-DD-YY HH:mm:ss');
					if (obj.published)
						obj.readablePublished = moment(obj.published).format('M-DD-YY HH:mm:ss');
					
					if (obj.published)
					{
						if (obj.activeRevision)
						{
							scope.historyObjsMap.published = obj;
							obj.type = types.published;
						}
						else
						{
							scope.historyObjsMap.history.push(obj);
							obj.type = types.history;
						}
					}
					else if (!obj.published)
					{
						scope.historyObjsMap.draft = obj;
						obj.type = types.draft;
					}
					
					return obj;
				}
				
				function resetHistoryObjsMap()
				{
					Object.assign(scope.historyObjsMap, {
						current: undefined,
						published: undefined,
						draft: undefined,
						history: []
					});
					return scope.historyObjsMap;
				}
				
				function formatError(obj, error)
				{
					return error + ', endpoint: ' + scope.endPoint + ', id: ' + obj.id;
				}
				
				/**
				 * Sets the provided object as the active revision with an optional publishing comment.
				 * Calls set onRevisionMadeActiveCallbacks once completed.
				 * @param object
				 * @param {String=} withComment
				 * @return {*}
				 */
				scope.setActiveRevision = function(object, withComment)
				{
					var toSend = { publish: true };
					if (typeof withComment === 'string' && withComment.length)
					{
						toSend.versionNote = withComment.slice(0, 250);
					}
					
					return $http.patch(object._links.self.href, toSend, {
						noErrorPopup: true
					})
						.then(function()
						{
							// Get current version of the object
							return scope.getCurrentVersionOf(object)
								.then(function(obj)
								{
									if (obj)
										object = obj;
									return scope.setComplexObject(object);
								})
						},
						function(error){
							errorHandler.handle('An error occurred while publishing this draft', formatError(object, error), true)
						}).finally(function ()
						{
							scope.cancelEditComment();
							onRevisionMadeActiveCallbacks.forEach(function (callback)
							{
								try {
									callback(object)
								} catch (e) {
									console.error(e)
								}
							});
						});
				};
				
				/**
				 * Deletes the provided object. Sets the current complexObject to the latest if the deleted is removed.
				 * @param object
				 * @return {*}
				 */
				scope.deleteRevision = function(object)
				{
					function triggerDeletionCallbacks(deleted, current)
					{
						onDeleteCallbacks.forEach(function(callback)
						{
							try {
								// Pass the deleted object and the new complex object
								callback(deleted, current)
							} catch (e) {
								console.error(e)
							}
						});
					}
					
					return $http.delete(object._links.self.href, {
						noErrorPopup: true
					})
						.then(() =>
						{
							if (object === scope.historyObjsMap.current)
							{
								var arr = scope.historyObjsMap.getAll();
								if (arr.length - 1 <= 0)
								{
									triggerDeletionCallbacks(object, undefined);
									resetHistoryObjsMap();
									scope.dismiss();
									return;
								}
								scope.complexObject = (arr[0] === object) ? arr[1] : arr[0];
							}
							return scope.setComplexObject(scope.complexObject)
								.then(() =>
								{
									triggerDeletionCallbacks(object, scope.complexObject);
									if (scope.historyObjsMap.getAll().length <= 0 && scope.autoDismissEnabled)
										scope.dismiss();
								});
						}, (error) => {
							errorHandler.handle('An error occurred while deleting this revision', formatError(object, error), true);
						})
				};
				
				/**
				 * Saves a publishing comment to an object
				 * @param object
				 * @param {String} comment
				 * @return {HttpPromise}
				 */
				scope.saveVersionComment = function(object, comment)
				{
					if (typeof comment === 'string')
						comment = comment.slice(0, 250)
					
					return $http.patch(object._links.self.href, { versionNote: comment }, {
						noErrorPopup: true,
						rawError: true
					})
						.then(function()
						{
							object.versionNote = comment;
						}, function(error)
						{
							errorHandler.handle('An error occurred while saving the comment.', formatError(object, error), true);
						})
						.finally(function()
						{
							scope.cancelEditComment();
						})
				};
				
				scope.startEditComment = function()
				{
					scope.versionComment = scope.getCurrentHistoryObject().versionNote || '';
					scope.editingComment = true;
				}
				
				scope.cancelEditComment = function()
				{
					scope.versionComment = '';
					scope.editingComment = false;
				}
				
				/**
				 * Calls set on edit callbacks with the selected revision
				 * @param object
				 */
				scope.editRevision = function(object)
				{
					onEditCallbacks.forEach(function(callback)
					{
						try {
							callback(object)
						} catch (e) {
							console.error(e)
						}
					})
				};
				
				/**
				 * Calls set onCopy callbacks with the selected revision
				 */
				scope.copyRevision = function(object)
				{
					onCopyCallbacks.forEach(function(callback)
					{
						try {
							callback(object)
						} catch (e) {
							console.error(e)
						}
					})
				};
				
				/**
				 * Gets the current published version of the current complexObject's complex object ID
				 * @param object
				 * @return {*}
				 */
				scope.getPublishedOf = function(object)
				{
					return $http.get('/api/' + scope.endPoint, {
						params: {
							size: 1,
							isDraft: false,
							activeRevision: true,
							saveInProgress: false,
							'complexObject.id': object.complexObject.id
						}
					})
						.then(function(results)
						{
							results = results.data._embedded[scope.endPoint][0];
							object.hasPublished = !!results;
							
							if (object.hasPublished)
								return prepare(results);
						})
				};
				
				/**
				 * Gets the current draft version of the current complexObject's complex object ID
				 * @param object
				 * @return {*}
				 */
				scope.getDraftOf = function(object)
				{
					return $http.get('/api/' + scope.endPoint, {
						params: {
							size: 1,
							isDraft: true,
							activeRevision: false,
							saveInProgress: false,
							'complexObject.id': object.complexObject.id
						}
					})
						.then(function(results)
						{
							results = results.data._embedded[scope.endPoint][0];
							object.hasDraft = !!results;
							
							if (object.hasDraft)
								return prepare(results);
						})
				};
				
				/**
				 * Returns a promise to be resolved with the amount of pages of historical revisions that match an objects
				 * complex object ID
				 * @param object
				 * @return {*}
				 */
				scope.getObjectHistoryPageCount = function(object)
				{
					return $http.get('/api/' + scope.endPoint, {
						params: {
							size: 0,
							page: 1,
							'complexObject.id': object.complexObject.id,
							isDraft: false,
							saveInProgress: false,
							activeRevision: false
						}
					})
						.then(function(results)
						{
							object.hasHistory = (scope.paging.elements = results.data.page.totalElements) > 0;
							scope.paging.count = Math.ceil( scope.paging.elements / scope.paging.pageSize);
							
							return scope.paging.count;
						})
				};
				
				/**
				 * Replaces historyObjsMap.history with a page of revisions and returns a promise of the same array
				 * @param {Number} pageNumber
				 * @return {*}
				 */
				scope.setHistoryPage = function(pageNumber)
				{
					pageNumber -= 1;
					return $http.get('/api/' + scope.endPoint, {
						params: {
							size: scope.paging.pageSize,
							page: pageNumber,
							'complexObject.id': scope.complexObject.complexObject.id,
							sort: 'published,desc',
							isDraft: false,
							activeRevision: false,
							saveInProgress: false
						}
					})
						.then(function(results)
						{
							var cObj = scope.getCurrentHistoryObject();
							scope.historyObjsMap.history = [];
							return results.data._embedded[scope.endPoint].map(function(obj)
							{
								prepare(obj);
								if (cObj && obj.id === cObj.id)
									scope.setCurrentHistoryObject(obj);
								return obj;
							});
						})
				};
				
				/**
				 * Gets the current version of the provided object and is fetched using the objects ID
				 * @param object
				 * @return {*}
				 */
				scope.getCurrentVersionOf = function(object)
				{
					return $http.get('/api/' + scope.endPoint, {
						params: {
							id: object.id,
							saveInProgress: false
						}
					})
						.then(function(result)
						{
							return result.data._embedded[scope.endPoint][0];
						},
						function()
						{
							return undefined;
						})
				};
				
				var settingComplexObject = false;
				/**
				 * Sets the manager's current complexObject to base off of.
				 * @param object
				 * @return {Promise<R> | Promise}
				 */
				scope.setComplexObject = function(object)
				{
					if (settingComplexObject)
						return $q.reject();
					
					settingComplexObject = true;
					scope.showLoading = true;
					
					var oldCpxObj = scope.complexObject;
					scope.complexObject = object;
					Object.assign(scope.historyObjsMap, {
						current: undefined,
						published: undefined,
						draft: undefined,
						history: []
					});
					return $q.when(!scope.complexObject || !scope.complexObject.complexObject
						? $q.reject()
						: $q.all([scope.getPublishedOf(scope.complexObject),
						scope.getDraftOf(scope.complexObject),
						scope.getObjectHistoryPageCount(scope.complexObject)
							.then(function()
							{
								if (scope.complexObject.hasHistory)
									return scope.setHistoryPage(scope.paging.current);
								else
									return [];
							})]))
						.finally(function()
						{
							function execCallback(callback)
							{
								try {
									callback(scope.complexObject, oldCpxObj);
								}
								catch (e) {
									console.error(e);
								}
							}
							
							settingComplexObject = false;
							scope.showLoading = false;
							
							if (!scope.complexObject)
								return ;
							
							if (!Object.keys(scope.historyObjsMap.getAll()).length)
							{
								// Execute callbacks if no history objects are available to be set as cpxObject
								onCpxObjectChangedCallbacks.forEach(execCallback);
								return;
							}
							
							// Sets the complex object to the first available one
							// in the event the complex object being used is no longer available.
							scope.complexObject = scope.historyObjsMap.getMap()[scope.complexObject.id]
								|| scope.historyObjsMap.draft || scope.historyObjsMap.published || scope.historyObjsMap.getAll()[0];
							
							scope.setCurrentHistoryObject(scope.complexObject);
							
							onCpxObjectChangedCallbacks.forEach(execCallback);
						});
				};
				
				/**
				 * Sets the current complex object to be detailed
				 * @param object
				 */
				scope.setCurrentHistoryObject = function(object)
				{
					scope.cancelEditComment();
					
					if (scope.historyObjsMap.current)
						scope.historyObjsMap.current.editingComment = false;
					
					scope.historyObjsMap.current = object;
				};
				
				/**
				 * Gets the current history object that is being detailed
				 * @return {undefined}
				 */
				scope.getCurrentHistoryObject = function()
				{
					return scope.historyObjsMap.current;
				};
				
				/**
				 * Destroys the manager's scope
				 */
				scope.dismiss = function()
				{
					if (scope.keepAlive)
					{
						onCloseCallbacks.forEach(function(callback)
						{
							try {
								callback()
							} catch (e) {
								console.error(e)
							}
						});
						
						$(document).off('keyup', escHandler);
					}
					else
						scope.$destroy();
				};
				
				/**
				 * Adds a callback to be triggered when edit is triggered on a revision
				 * @param {Function<Object>} callback
				 */
				scope.addEditCallback = function(callback)
				{
					if (typeof callback === 'function')
						onEditCallbacks.push(callback);
					
					return scope;
				};
				
				/**
				 * Adds a callback to be triggered when a revision is deleted
				 * @param {Function<Object, Object>} callback - Deleted and current complex objects are passed
				 */
				scope.addDeleteCallback = function(callback)
				{
					if (typeof callback === 'function')
						onDeleteCallbacks.push(callback);
					
					return scope;
				};
				
				/**
				 * Adds a callback to be triggered when a revision is made to be the published version
				 * @param {Function<Object>} callback
				 */
				scope.addRevisionMadeActiveCallback = function(callback)
				{
					if (typeof callback === 'function')
						onRevisionMadeActiveCallbacks.push(callback);
					
					return scope;
				};
				
				/**
				 * Adds a callback to be triggered when the scope is destroyed
				 * @param {Function} callback
				 */
				scope.addOnCloseCallback = function(callback)
				{
					if (typeof callback === 'function')
						onCloseCallbacks.push(callback);
					
					return scope;
				};
				
				/**
				 * Adds a callback to be triggered when the copy button is selected
				 * @param callback
				 */
				scope.addOnCopyCallback = function(callback)
				{
					if (typeof callback === 'function')
						onCopyCallbacks.push(callback);
					
					return scope;
				};
				
				/**
				 * Adds a callback to be triggered when the current referenced complex object is changed
				 * @param {function<Object,Object>} callback
				 * @return {*}
				 */
				scope.addOnComplexObjectChangedCallback = function(callback)
				{
					if (typeof callback === 'function')
						onCpxObjectChangedCallbacks.push(callback);
					
					return scope;
				};
				
				/**
				 * Returns if there are onCopy callbacks
				 * @return {boolean}
				 */
				scope.hasCopyCallbacks = function()
				{
					return !!onCopyCallbacks.length;
				};
				
				/**
				 * Sets a predicate to evaluate if a user has delete access for an item
				 * @param predicate {function}
				 */
				scope.setDeleteAvailablePredicate = function(predicate)
				{
					if (typeof predicate === 'function')
						deleteAvailablePredicate = predicate;
				}
				
				/**
				 * Sets a predicate to evaluate if a user has publish access for an item
				 * @param predicate
				 */
				scope.setPublishAvailablePredicate = function(predicate)
				{
					if (typeof predicate === 'function')
						publishAvailablePredicate = predicate;
				}
				
				/**
				 * Sets a predicate to evaluate if a user has commenting access for an item
				 * @param predicate
				 */
				scope.setCommentAvailablePredicate = function(predicate)
				{
					if (typeof predicate === 'function')
						commentAvailablePredicate = predicate;
				}
				
				/**
				 * Evaluates a provided object against the stored predicate to determine deletion availability.
				 * Returns true if no predicate has been set.
				 * @param obj
				 * @return {boolean}
				 */
				scope.evaluateDeleteAvailable = function(obj)
				{
					return (typeof deleteAvailablePredicate === 'function') ? !!deleteAvailablePredicate(obj) : true;
				}
				
				/**
				 * Evaluates a provided object against the stored predicate to determine publishing availability.
				 * Returns true if no predicate has been set.
				 * @param obj
				 * @return {boolean}
				 */
				scope.evaluatePublishAvailable = function(obj)
				{
					return (typeof publishAvailablePredicate === 'function') ? !!publishAvailablePredicate(obj) : true;
				}
				
				/**
				 * Evaluates a provided object against the stored predicate to determine commenting availability.
				 * Returns true if no predicate has been set.
				 * @param obj
				 * @return {boolean}
				 */
				scope.evaluateCommentAvailable = function(obj)
				{
					return (typeof commentAvailablePredicate === 'function') ? !!commentAvailablePredicate(obj) : true;
				}
				
				/**
				 * Returns if there are onEdit callbacks
				 * @return {boolean}
				 */
				scope.hasEditCallbacks = function()
				{
					return !!onEditCallbacks.length;
				};
				
				if (typeof scope.watchComplex === 'function')
				{
					scope.$watch(scope.watchComplex, function(newVal, oldVal)
					{
						if (newVal === oldVal)
							return;
						scope.setComplexObject(newVal);
					});
					scope.setComplexObject(scope.watchComplex())
				}
				else
					scope.setComplexObject(scope.complexObject);
				
				function escHandler($event)
				{
					$timeout(function()
					{
						if ($event.key === 'Escape')
						{
							if (scope.historyObjsMap.current && scope.historyObjsMap.current.editingComment)
							{
								scope.historyObjsMap.current.editingComment = false;
							}
							else
								scope.dismiss();
						}
					});
				};
				
				scope.$on('$destroy', function()
				{
					onCloseCallbacks.forEach(function(callback)
					{
						try {
							callback()
						} catch (e) {
							console.error(e)
						}
					});
					
					$(document).off('keyup', escHandler);
				});
				
				$(document).on('keyup', escHandler);
			},
			
			post: function(scope, elem, attr)
			{
				
				scope.keepAlive = !!attr.hasOwnProperty('keepAlive');
				
				scope.openHelp = function()
				{
					scope.$emit('openHelp', 'version-manager');
				}
				
				scope.addRevisionMadeActiveCallback(scope.onRevisionMadeActive);
				scope.addEditCallback(scope.onEdit);
				scope.addDeleteCallback(scope.onDelete);
				scope.addOnCloseCallback(scope.onClose);
				scope.addOnCopyCallback(scope.onCopy);
				scope.addOnComplexObjectChangedCallback(scope.onComplexObjectChanged);
				
				if (typeof scope.onBind === 'function')
					scope.onBind(scope, elem, attr);
				
				if (typeof scope.css === 'object')
				{
					for (var key in scope.css)
					{
						$(elem).css(key, scope.css[key])
					}
				}
			}
		}
	}
}]);